export default {
    happinessTips: [],
    loading: false
};
